import React from 'react';
import FooterListItem from './FooterListItem';
import { useSelector } from 'react-redux';

const OutstandingItems = () => {
    const outstandingItems = useSelector((state) => state.outstandingItems)
    
    return (
        <div className="outstanding-items">
            <h1>Outstanding items from current invoice</h1>
            <section className="invoice-line-item-container">
                <article className="invoice-line-item header">
                    <span className="flex-20">Client</span>
                    <span className="flex-20">Appointment type</span>
                    <span className="flex-20" style={{flex: "12% 2"}}>Date</span>
                    <span className="flex-20" style={{flex: "10% 2"}}>Counsellor rate</span>
                    <span className="flex-20" style={{flex: "40% 2"}}>Comment</span>
                </article>
            </section>
            {
                outstandingItems.map(item => (
                    <FooterListItem 
                        item={item}
                        isOutstanding={true}
                    />
                ))
            }
        </div>
    );
};

export default OutstandingItems;